import { planPrivilegeStore } from '@shared/store/plan-privilege.store';
import { PlanMap } from '@shared/types/components/role/plan-guard.types';

export const hasPlanAccess = (privileges: PlanMap | PlanMap[]): boolean[] => {
  const { planPrivileges } = planPrivilegeStore.getState();

  // change the string to array here so we don't need to pass array for single privilege
  if (typeof privileges === 'string') privileges = [privileges];

  const defaultAccess = Array(privileges.length).fill(false);
  let access: boolean[] = defaultAccess;

  if (!planPrivileges) return defaultAccess;

  access = privileges.reduce((acc: boolean[], curr) => {
    return [...acc, !!planPrivileges[curr]];
  }, []);

  return access;
};
